var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"company-source-label",attrs:{"src":require('@/assets/images/Group 2418.svg'),"alt":"自社HP経由登録"}})])}
var staticRenderFns = []

export { render, staticRenderFns }